import { MemberMemberGroups as MemberMemberGroupsComponent } from '../../../components/Member';

export function MemberMemberGroups() {
  return <MemberMemberGroupsComponent />;
}
